import { render, staticRenderFns } from "./ClassTree.vue?vue&type=template&id=4a1bc47c&scoped=true&"
import script from "./ClassTree.vue?vue&type=script&lang=js&"
export * from "./ClassTree.vue?vue&type=script&lang=js&"
import style0 from "./ClassTree.vue?vue&type=style&index=0&id=4a1bc47c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1bc47c",
  null
  
)

export default component.exports